// ABOUTME: Shared mutex for token refresh across all API slices.
// ABOUTME: Prevents race conditions when multiple slices attempt to refresh the token simultaneously.
import { Mutex } from 'async-mutex';

export const authMutex = new Mutex();
